import { IsNumber } from 'class-validator';
import { GiftCardRefundBaseRequestDto } from './gift-card-refund-base-request.dto';

export class GiftCardDigitalRefundRequestDto extends GiftCardRefundBaseRequestDto {
  @IsNumber()
  digitalGiftCardId: number;

  constructor(from?: {
    digitalGiftCardId: number;
    refundReasonId: number;
    commentReason: string;
  }) {
    super();

    if (!from) {
      return;
    }
    this.digitalGiftCardId = from.digitalGiftCardId;
    this.refundReasonId = from.refundReasonId;
    this.commentReason = from.commentReason;
  }
}
